export default __webpack_public_path__ + "email-summary.svg";